import { Box, Fab, useMediaQuery } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { theme } from "app/App";

// TODO: o botão em mobile oculta uma parte do final da tela
export default function ActionButton({ label, icon = <AddIcon />, sx, ...props }) {
    const smallScreen = useMediaQuery(theme.breakpoints.down("sm"));
    // Oculta label em mobile.
    // label = !smallScreen ? label : null;

    return (
        <Fab
            // variant={label ? "extended" : null}
            variant="extended"
            color="primary"
            // sx={{ position: { xs: "fixed", sm: "static" }, bottom: "15px", right: "15px", ...sx }}
            sx={{ borderRadius: "12px" }}
            {...props}
        >
            {icon}
            {label ? <Box sx={{ ml: 1 }}>{label}</Box> : null}
        </Fab>
    );
}
